<template>
  <div class="py-2 relative-position">
    <v-card-title class="title">
      {{ accion.title }}
      <copy-chip v-if="cliente" :text="cliente+'/'+instalacion+'/'+incidencia" class="subheading" />
    </v-card-title>
    <v-divider />
    <div class="pa-3">
      <v-autocomplete v-if="!accion.tecnicoDisabled" v-model="tecnico" :items="tecnicoArray" :allow-overflow="false"
                      :menu-props="{maxHeight:200}" :filter="selectFilterIncludes" :autofocus="tecnico === null"
                      label="Tecnico Asignado" item-text="label" item-value="value"
                      class="mr-3 select-inline" chip mall-chips attach
      />
      <v-textarea v-model="motivo" :max-height="100" :error-messages="isRequired" type="textarea" rows="3" label="Motivo" />
      <v-textarea v-model="observaciones" :max-height="100" type="textarea" rows="3" label="Observaciones de incidencia" />
      <div class="mt-3 text-center layout row justify-center">
        <v-btn push color="success" @click="transfer">
          {{ accion.title }}
        </v-btn>
      </div>
    </div>
    <inner-loading :visible="loading" />
  </div>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import { Entities, Forms } from 'mixins/index.js'
import { EventBus } from '@/store/EventBus.js'
import CopyChip from '@/components/CopyChip'

export default {
  name: 'ModalTransfer',
  components: { InnerLoading, CopyChip },
  mixins: [Entities, Forms],
  props: {
    componentProps: { type: Object, required: true }
  },
  data () {
    return {
      reload: false,
      loading: false,
      accion: { title: 'Traspasar incidencia',
        messageTo: 'Incidencia traspasada correctamente',
        estado: '',
        emitReload: true,
        postAction: null,
        required: false
      },
      tecnicoArray: [],
      tecnico: '',
      motivo: '',
      observaciones: '',
      cliente: '',
      instalacion: '',
      incidencia: ''
    }
  },
  computed: {
    isRequired () {
      return !!this.accion.required && !this.motivo ? 'Campo requerido' : ''
    }
  },
  beforeMount () {
    this.show(this.componentProps)
  },
  methods: {
    show ({ TecnicoAsignado, Cliente, Instalacion, Incidencia, Observaciones, Accion }) {
      this.tecnicoArray = this.getEntity('tecnico')
      this.tecnico = TecnicoAsignado
      this.cliente = Cliente
      this.instalacion = Instalacion
      this.incidencia = Incidencia
      this.observaciones = Observaciones
      if (Accion) { this.accion = Accion } else {
        this.accion = { title: 'Traspasar incidencia', messageTo: 'Incidencia traspasada correctamente', estado: '', emitReload: true }
      }
    },
    close () {
      this.loading = false
      EventBus.$emit('closeModal', true)
      if (this.reload) { EventBus.$emit('reloadRequest') }
    },
    transfer () {
      if (this.tecnico >= 0 && ((this.accion.required && this.motivo) || !this.accion.required)) {
        if (this.tecnico === 96) {
          this.loading = true

          Promise.all([
            this.axios.get(
              `${this.$apiUrl('incidencia')}?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}`,
              { headers: { 'Content-Type': 'application/json' } }
            ),
            this.axios.get(
              `${this.$apiUrl('file')}?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}`,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            )
          ])
            .then(([incidenciaResp, filesResp]) => {
              let data = incidenciaResp.data
              let archivos = filesResp.data || []
              let errors = []

              if (!data.DescripcionTecnica || data.DescripcionTecnica.length === 0) {
                errors.push('La descripción técnica es obligatoria para traspasar a este técnico.')
              } else if (data.DescripcionTecnica.length > 160) {
                errors.push('La descripción técnica no puede superar los 160 caracteres.')
              }
              if (!data.Descripcion || data.Descripcion.length === 0) {
                errors.push('La descripción es obligatoria para traspasar a este técnico.')
              }
              if (archivos.length === 0) {
                errors.push('Debe haber al menos un archivo adjunto para traspasar a este técnico.')
              }

              if (errors.length) {
                errors.forEach(msg => {
                  this.$notify({ message: msg, type: 'error' })
                })
                this.loading = false
                return
              }
              this.doTransfer()
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.doTransfer()
        }
      }
    },
    doTransfer () {
      this.loading = true
      this.reload = false
      let incidencia = {
        Cliente: this.cliente,
        Instalacion: this.instalacion,
        Incidencia: this.incidencia,
        TecnicoAsignado: this.tecnico,
        Observaciones: this.observaciones,
        Estado: this.accion.estado || ''
      }
      this.axios
        .post(this.$apiUrl('traspasarIncidencia') + `?motivo=${this.motivo}`, incidencia)
        .then(resp => {
          this.$notify({ message: `${this.accion.messageTo} a : ${this.findLabel('tecnico', this.tecnico)}` })
          this.reload = this.accion.emitReload
          if (this.accion.postAction) this.postAction(this.accion.postAction)
        })
        .catch(() => { })
        .then(() => {
          this.close()
        })
    }
  }

}
</script>
